// --------------------- Import Globais ---------------------
import { useState, useEffect } from "react";
import { useMediaQuery } from "@mui/material";
// --------------------- Import Antd-Design ---------------------
import {
  Col,
  Flex,
  Row,
  Button,
  MenuProps,
  Skeleton,
  Table,
  Typography,
} from "antd";
import type { TableProps } from "antd/es/table";
// --------------------- Import Material Icon ---------------------
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

import { useBuscarParceiros } from "./hooks/useParceiros";
import { Columns } from "./components/Columns";
import { Container } from "./styles";
import ModalAdicionar from "./components/ModalAdicionar";
import ModalEditar from "./components/ModalEditar";
import { cotaService } from "../../services/cotaService";

export default function ViewGerenciarParceiros() {
  // Traz o estilo Title da biblioteca
  const { Title } = Typography;
  const isMobile = useMediaQuery("(max-width:600px)");
  const { parceiros, isLoading, buscar } = useBuscarParceiros();

  const [parceiroId, setParceiroId] = useState<number | null>(null);

  // Controle de Paginação
  const [currentPage, setCurrentPage] = useState(1);

  // Inicializando o filtro
  const [filteredInfo, setFilteredInfo] = useState<{
    nome?: string[] | null;
    descricao?: string[] | null;
    active?: number[] | null;
  }>({
    nome: null,
    descricao: null,
    active: null,
  });
  const [semFiltros, setSemFiltros] = useState(true);

  useEffect(() => {
    const filtros = localStorage.getItem("filtrosPropriedades");
    const pagina = localStorage.getItem("pageGerPropriedades");

    if (filtros) {
      const novoFiltro = JSON.parse(filtros);
      setFilteredInfo({
        nome: novoFiltro.nome ? [novoFiltro.nome] : null,
        descricao: novoFiltro.descricao ? [novoFiltro.descricao] : null,
        active: novoFiltro.active ? [novoFiltro.active] : null,
      });
      setSemFiltros(false);
    }

    if (pagina) {
      setCurrentPage(Number(pagina));
    }
  }, []);

  const onChange: TableProps<any>["onChange"] = (pagination, filters) => {
    setFilteredInfo({
      nome: filters.nome as string[] | null,
      descricao: filters.descricao as string[] | null,
      active: filters.active as number[] | null,
    });

    const hasFilters = Boolean(
      filters.nome || filters.descricao || filters.active
    );
    setSemFiltros(!hasFilters);

    if (pagination.current) {
      localStorage.setItem(
        "pageGerPropriedades",
        pagination.current.toString()
      );
    }

    localStorage.setItem("filtrosPropriedades", JSON.stringify(filters));
  };

  const removerFiltros = () => {
    localStorage.removeItem("filtrosPropriedades");
    localStorage.removeItem("pageGerPropriedades");

    setFilteredInfo({
      nome: null,
      descricao: null,
      active: null,
    });
    setSemFiltros(true);
    setCurrentPage(1);
  };

  const handleFilter = () => {
    removerFiltros();
  };

  // OnClick das opções e funções que serão realizadas do item Ações
  const onClick: MenuProps["onClick"] = async ({ key }) => {
    switch (key) {
      // Editar
      case "1":
        handleModalEdit();
        break;
      // Excluir
      case "2":
        //handleModalStatus();
        break;
    }
  };
  // Traz as informações  OnClick, origem , nome e id do apartamento além do nome do empreendimento, ao clickar na linha especifica
  const columns = Columns(onClick, setParceiroId, {
    nome: filteredInfo.nome,
    descricao: filteredInfo.descricao,
    active: filteredInfo.active,
  });

  const [openModalAdd, setOpenModalAdd] = useState(false);

  const handleModalAdd = () => {
    setOpenModalAdd(!openModalAdd);
  };

  const [openModalEdit, setOpenModalEdit] = useState(false);

  const handleModalEdit = () => {
    setOpenModalEdit(!openModalEdit);
  };

  const [openModalExcluir, setOpenModalExcluir] = useState(false);

  const handleModalExcluir = () => {
    setOpenModalExcluir(!openModalExcluir);
  };

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <Container>
          <Row>
            <Col span={5}>
              <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                <a href={`/gerenciar`}>
                 
                </a>
              </Flex>
            </Col>
            <Col span={12}>
              <Flex align="center" justify="center">
                <HomeIcon color="primary" fontSize="large" />
                <Title
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                    fontSize: isMobile ? "1rem" : "2rem",
                    color: "rgb(0, 54, 68)",
                  }}
                  level={3}
                >
                  Gerenciar Parceiros
                </Title>
              </Flex>
            </Col>
          </Row>

          <Row>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                height: "auto",
                width: "90%",
                gap: "20px",
              }}
            >
              <div style={{ display: "flex", gap: "20px" }}>
                <Button
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "auto",
                  }}
                  onClick={handleModalAdd}
                  type="primary"
                >
                  + Parceiro
                </Button>

                {semFiltros ? (
                  <Button onClick={handleFilter} type="primary" disabled>
                    <FilterAltIcon />
                  </Button>
                ) : (
                  <Button onClick={handleFilter} type="primary">
                    <FilterAltOffIcon />
                  </Button>
                )}
              </div>
            </div>
            <Col span={isMobile ? 5 : 1}></Col>

            <Col
              span={22}
              style={{
                marginTop: isMobile ? 15 : 15,
                marginBottom: isMobile ? 30 : 50,
              }}
            >
              <Flex
                style={{
                  width: isMobile ? "auto" : "100%",
                  overflow: "auto",
                  marginLeft: 30,
                }}
              >
                <Table
                  rowKey="id"
                  columns={columns}
                  dataSource={parceiros}
                  onChange={onChange}
                  bordered
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: isMobile ? "auto" : "100%",
                    maxWidth: isMobile ? "none" : "100%",
                  }}
                  pagination={{ defaultCurrent: currentPage }}
                />
              </Flex>
            </Col>

            <Col span={1}></Col>
          </Row>
        </Container>
      )}
      <ModalAdicionar
        isModalOpen={openModalAdd}
        handleFechar={handleModalAdd}
        buscar={buscar}
      />
      <ModalEditar
        isModalOpen={openModalEdit}
        handleFechar={handleModalEdit}
        parcerioId={parceiroId!}
        buscar={buscar}
      />
    </>
  );
}
